
define('txt!tmpl/ctas.hbs',[],function () { return '\n{{#each ctas}}\n  <a href="{{href}}" class="{{class}}" target="{{target}}" data-destination="{{destination}}" data-km="{{km}}">\n    {{label}}\n    {{#if_eq destination \'deal-builder\'}}\n      <i class="icon-linkout-after marg-left-2-sm"></i>\n    {{/if_eq}}\n  </a>\n{{/each}}\n';});

